import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'reactstrap';
import { Search, X, Sliders, RotateCcw, UserPlus } from 'react-feather';
import Loader from '../../../layouts/loader/Loader';
import '../../../assets/styles/login/styles.css';
import useFormularioUsuarios from './hooks/useFormularioUsuarios';
import FiltrosBusqueda from './FiltrosBusqueda';
import TablaResultados from './TablaResultados';
import colors from '../../../theme/colors';

const boton = (primario) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '7px 14px',
  fontSize: '0.8125rem',
  fontWeight: 600,
  borderRadius: '8px',
  border: primario ? 'none' : '1px solid #e5e7eb',
  backgroundColor: primario ? colors.primary : '#fff',
  color: primario ? '#fff' : '#374151',
  cursor: 'pointer',
});

const FormularioUsuarios = () => {
  // Los datos mandan: la tabla ocupa la pantalla y los filtros del formulario
  // viven plegados detrás del botón de la barra.
  const [showFilters, setShowFilters] = useState(false);
  const formRef = useRef(null);
  const buscadoRef = useRef(false);
  const {
    name, lastname, dni, idUser, email, phone, idStripe,
    headquarter, year, cicle, type, course,
    formationCenter, deudores, selectedIds, setSelectedIds,
    headquarterList, formationList, yearList, typeList, cicleList, courseList,
    data, searchMeta, isFormSubmittable, isTableNotLoading, isLoadingMore, loadMore, userOU, searchContext,
    tablaEstandar, busquedaRapida, setBusquedaRapida, loadFacets, exportar, isExporting, exportError,
    handleNameOnChange, handleLastNameOnChange, handleDNIOnChange,
    handleIDOnChange, handleEmailOnChange, handlePhoneOnChange,
    handleHeadquarter, handleFormationCenter, handleYear,
    handleType, handleCicle, handleCourse, handleDeudor,
    handleIdStripeOnChange, handleReset, handleOnSubmit, handleNavigateNuevoAlumno,
  } = useFormularioUsuarios();

  const isReady =
    headquarterList !== '' && cicleList !== '' &&
    typeList !== '' && courseList !== '' && userOU !== '';

  // Al entrar se muestran ya los alumnos (sin pulsar Buscar), salvo que se vuelva
  // desde una ficha: entonces el hook restaura la búsqueda anterior.
  const restaurando = searchContext !== '' && searchContext.newSearch === false;
  useEffect(() => {
    if (!isReady || !isFormSubmittable || restaurando || buscadoRef.current) return;
    buscadoRef.current = true;
    formRef.current?.requestSubmit?.();
  }, [isReady, isFormSubmittable, restaurando]);

  if (!isReady) return <Loader />;

  const filtrosFormulario = [
    name.data, lastname.data, dni.data, idUser.data, email.data, phone.data, idStripe.data,
  ].filter(Boolean).length + (deudores ? 1 : 0);

  return (
    <>
      <Form onSubmit={handleOnSubmit} innerRef={formRef}>
        <div
          style={{
            display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap',
            backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px',
            boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)', padding: '10px 14px',
          }}
        >
          <div style={{ position: 'relative', flex: '1 1 280px', maxWidth: 520 }}>
            <Search size={15} style={{ position: 'absolute', left: 10, top: 10, color: '#9ca3af' }} />
            <input
              type="search"
              value={busquedaRapida}
              onChange={(e) => setBusquedaRapida(e.target.value)}
              placeholder="Buscar por nombre, apellidos, DNI, email, móvil o ID…"
              aria-label="Buscar alumnos"
              style={{
                width: '100%', padding: '7px 30px 7px 32px', fontSize: '0.8125rem',
                border: '1px solid #e5e7eb', borderRadius: '8px', background: '#fff',
              }}
            />
            {busquedaRapida && (
              <button
                type="button"
                aria-label="Borrar búsqueda"
                onClick={() => setBusquedaRapida('')}
                style={{ position: 'absolute', right: 6, top: 6, border: 0, background: 'none', color: '#9ca3af', cursor: 'pointer' }}
              >
                <X size={15} />
              </button>
            )}
          </div>

          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              aria-expanded={showFilters}
              title="Más filtros"
              style={{ ...boton(false), ...(showFilters || filtrosFormulario ? { borderColor: colors.primary, color: colors.primary } : {}) }}
            >
              <Sliders size={14} />
              Filtros{filtrosFormulario ? ` (${filtrosFormulario})` : ''}
            </button>
            <button type="button" onClick={handleNavigateNuevoAlumno} style={boton(true)}>
              <UserPlus size={14} />
              Nuevo
            </button>
          </div>
        </div>

        {showFilters && (
          <div
            style={{
              marginTop: '8px', backgroundColor: '#fff', border: '1px solid #e5e7eb',
              borderRadius: '12px', padding: '16px',
              opacity: !isTableNotLoading ? 0.5 : 1,
              pointerEvents: !isTableNotLoading ? 'none' : 'auto',
            }}
          >
            <FiltrosBusqueda
              searchContext={searchContext}
              isTableNotLoading={isTableNotLoading}
              name={name} lastname={lastname} dni={dni} idUser={idUser}
              email={email} phone={phone} idStripe={idStripe}
              headquarter={headquarter} headquarterList={headquarterList}
              year={year} yearList={yearList}
              type={type} typeList={typeList}
              cicle={cicle} cicleList={cicleList}
              course={course} courseList={courseList}
              formationList={formationList} formationCenter={formationCenter}
              selectedIds={selectedIds} setSelectedIds={setSelectedIds}
              deudores={deudores} userOU={userOU}
              handleNameOnChange={handleNameOnChange}
              handleLastNameOnChange={handleLastNameOnChange}
              handleDNIOnChange={handleDNIOnChange}
              handleIDOnChange={handleIDOnChange}
              handleYear={handleYear}
              handleHeadquarter={handleHeadquarter}
              handleType={handleType}
              handleCicle={handleCicle}
              handleCourse={handleCourse}
              handleEmailOnChange={handleEmailOnChange}
              handleFormationCenter={handleFormationCenter}
              handlePhoneOnChange={handlePhoneOnChange}
              handleIdStripeOnChange={handleIdStripeOnChange}
              handleDeudor={handleDeudor}
            />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '12px' }}>
              <button type="button" onClick={handleReset} disabled={!isTableNotLoading} style={boton(false)}>
                <RotateCcw size={13} />
                Limpiar
              </button>
              <button
                type="submit"
                disabled={!isFormSubmittable || !isTableNotLoading}
                style={{ ...boton(true), opacity: !isFormSubmittable || !isTableNotLoading ? 0.5 : 1 }}
              >
                <Search size={13} />
                {!isTableNotLoading ? 'Buscando...' : 'Aplicar filtros'}
              </button>
            </div>
          </div>
        )}
      </Form>
      <TablaResultados
        data={data}
        searchMeta={searchMeta}
        tabla={tablaEstandar}
        onLoadMore={loadMore}
        isLoadingMore={isLoadingMore}
        cargando={!isTableNotLoading}
        loadFacets={loadFacets}
        onExportar={exportar}
        isExporting={isExporting}
        exportError={exportError}
      />
    </>
  );
};

export default FormularioUsuarios;
